import { useEffect } from "react";
import { useLocation } from "react-router";
import { useAuth } from "./auth";
import { capturePostHogPageview, identifyPostHogUser, initPostHog, resetPostHog } from "./posthog";
import { syncSentryIdentity } from "./sentry";
import { useTierCredits } from "./tier-credits";
import { useIsAdmin } from "./useIsAdmin";

export function PostHogBridge() {
  const location = useLocation();
  const { user } = useAuth();
  const { status } = useTierCredits();
  const { isAdmin } = useIsAdmin();

  useEffect(() => {
    void initPostHog();
  }, []);

  useEffect(() => {
    const identity = user
      ? {
          userId: user.id,
          email: user.email ?? null,
          tier: status?.tier ?? null,
          isAdmin,
        }
      : null;

    void identifyPostHogUser(identity);
    void syncSentryIdentity(identity);
  }, [user?.id, user?.email, status?.tier, isAdmin]);

  useEffect(() => {
    const path = `${location.pathname}${location.search}${location.hash}`;
    void capturePostHogPageview(path);
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    return () => {
      void resetPostHog();
      void syncSentryIdentity(null);
    };
  }, []);

  return null;
}
